import { IAction } from '@Root/types'

export const ExternalChannelActionTypes = {
  GET_EXTERNAL_VIDEOS: '@@externalChannel/GET_EXTERNAL_VIDEOS',
  GET_EXTERNAL_VIDEOS_SUCCESS: '@@externalChannel/GET_EXTERNAL_VIDEOS_SUCCESS',
  GET_EXTERNAL_VIDEOS_FAILURE: '@@externalChannel/GET_EXTERNAL_VIDEOS_FAILURE',
  INCREASE_PAGE_COUNT: '@@externalChannel/INCREASE_PAGE_COUNT',
  DECREASE_PAGE_COUNT: '@@externalChannel/DECREASE_PAGE_COUNT',
  GET_EXTERNAL_CHANNELS: '@@externalChannel/GET_EXTERNAL_CHANNELS',
  GET_EXTERNAL_CHANNELS_SUCCESS: '@@externalChannel/GET_EXTERNAL_CHANNELS_SUCCESS',
  GET_EXTERNAL_CHANNELS_FAILURE: '@@externalChannel/GET_EXTERNAL_CHANNELS_FAILURE',
  OPEN_ACTIONS_DROPDOWN: '@@externalChannel/OPEN_ACTIONS_DROPDOWN',
  CLOSE_DROPDOWNS: '@@externalChannel/CLOSE_DROPDOWNS',
  REMOVE_EXTERNAL_CHANNEL: '@@externalChannel/REMOVE_EXTERNAL_CHANNEL'
}

export interface IExternalChannelState {
  readonly externalChannels: IExternalChannel[]
  readonly externalVideos: IExternalVideo[]
  readonly loadingVideos: boolean
  readonly loadingChannels: boolean
  readonly hasLoadedVideosOnce: boolean
  readonly page: {
    readonly totalCount: number
    readonly totalPages: number
    readonly currentPage: number
    readonly videosPerPage: number
    readonly actionsDropdownOpen: boolean
  }
}

export interface IExternalChannel {
  readonly id: string
  readonly service: string
  readonly name: string
  readonly thumbnailUrl: string
  readonly valid: boolean
  readonly verified: boolean
}

export interface IExternalVideo {
  readonly externalId: string
  readonly title: string
  readonly length: number
  readonly createdAt: string
  readonly thumbnailUrl: string
  readonly service: string
  readonly externalChannelId: string
  readonly externalChannelName: string
  readonly downloadUrl: string
  readonly canBeDownloaded: boolean
  readonly isReady: boolean
}

export interface IGetExternalVideosSuccessResponseBody {
  readonly videos: IExternalVideo[]
  readonly unprocessedChannelsIds: number[]
}

export interface IGetExternalChannelsSuccessResponseBody {
  readonly externalChannels: IExternalChannel[]
}

export interface IRemoveExternalChannelPayload {
  readonly externalChannelId: string
}

export type TExternalChannelActionTypes =
  IAction<IGetExternalVideosSuccessResponseBody> |
  IAction<IGetExternalChannelsSuccessResponseBody>
